import {cloneDeep, get} from 'lodash';
import {getArray, getBoolean, getNumber, getString} from 'Core/helpers/data';
import {SignalQualityDataObject, SignalQualityNightDataObject} from '../dataObjects';

/**
 * Get input data from raw data
 * @param {Object} rawData - Raw data received from IO.
 * @return {SignalQualityDataObject}
 */
export const input = rawData => {
	let result = cloneDeep(rawData);
	
	result = new SignalQualityDataObject(
		getString(result, 'id'),
		getArray(result, 'studyNightSignalQualityDataList').map(i => new SignalQualityNightDataObject(
			getString(i, 'studyNightId', null, true),
			getString(i, 'studyPreliminaryNightId', null, true),
			getNumber(i, 'night'),
			(get(i, 'grade') === null ? null : getNumber(i, 'grade', null)),
			getBoolean(i, 'reviewed'),
		)),
	);

	return result;
}